import { render, staticRenderFns } from "./GeneralSegmentContentDataInput.vue?vue&type=template&id=56ee30aa&"
import script from "./GeneralSegmentContentDataInput.vue?vue&type=script&lang=js&"
export * from "./GeneralSegmentContentDataInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports